import { useId, useState, type ReactNode } from "react";

interface Item {
  question: string;
  answer: ReactNode;
}

function Row({ item }: { item: Item }) {
  const [open, setOpen] = useState(false);
  const id = useId();

  return (
    <li className="border-b border-fg/15">
      <h3>
        <button
          type="button"
          aria-expanded={open}
          aria-controls={id}
          onClick={() => setOpen((value) => !value)}
          className="group flex w-full items-center justify-between gap-6 py-6 text-left"
        >
          <span className="text-lg font-medium tracking-[-0.02em] md:text-xl">{item.question}</span>
          <span className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-fg/20 transition-colors duration-300 group-hover:border-fg/60">
            <span className="absolute h-px w-3 bg-fg" />
            <span
              className={`absolute h-3 w-px bg-fg transition-transform duration-500 ease-out-expo ${open ? "scale-y-0" : "scale-y-100"}`}
            />
          </span>
        </button>
      </h3>
      {/* Grid rows animate between 0fr and 1fr, so the answer can be any height. */}
      <div
        id={id}
        role="region"
        className={`grid transition-[grid-template-rows,opacity] duration-500 ease-out-expo ${
          open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className={`overflow-hidden ${open ? "visible" : "invisible"}`}>
          <div className="max-w-[60ch] pb-7 text-mute">{item.answer}</div>
        </div>
      </div>
    </li>
  );
}

export function Accordion({ items }: { items: Item[] }) {
  return (
    <ul className="border-t border-fg/15">
      {items.map((item) => (
        <Row key={item.question} item={item} />
      ))}
    </ul>
  );
}
